import React from 'react';
import { all, put, takeEvery, select, take } from 'redux-saga/effects';
import { toSuccess } from 'react-async-client';
import { notification } from 'antd';
import Translate from 'react-translate-component';
import moment from 'moment';
import { prop, path } from 'ramda';

import { handleVersionChange } from 'utils/version';
import { profile, main } from 'constants/routes';
import { DATE_FORMATS } from 'constants/dateFormats';
import { LOCATION_CHANGE, GET_USER, CHANGE_USER_PASSWORD } from 'constants/actionTypes';
import { logout, licenseCheck } from 'actions/userActions';
import { getUser } from 'actions/asyncActions';
import { history } from 'store/browserHistory';

const checkNeedUpdatePassword = function* (action) {
    const user = yield select(getUser.selectData);

    if (prop('needUpdatePassword', user) && !profile.match(path(['location', 'pathname'], action.payload))) {
        history.push(profile.path);
    }
};

export default function* license() {
    yield all([
        takeEvery(toSuccess(GET_USER), function* checkLicense(action) {
            handleVersionChange(action.payload);
            const license = action.payload.license;

            if (license) {
                let isLicenseExpired = false;
                const endDate = moment(license, DATE_FORMATS.parse);
                const showDate = moment(localStorage && localStorage.getItem('licenseShowDate'), DATE_FORMATS.parse);
                const daysToEnd = endDate.diff(moment(), 'day');

                if ((0 < daysToEnd && daysToEnd < 7) && !moment().isSame(showDate, 'day')) {
                    const description = <Translate content="errors.licenseWillExpireSoon" with={{ date: endDate.format(DATE_FORMATS.format) }} unsafe />;
                    const message = <Translate content="errors.warning" />;
                    notification.open({ message, description, duration: 10, className: 'notification-license' });
                    localStorage && localStorage.setItem('licenseShowDate', moment().format(DATE_FORMATS.parse));
                }

                if (daysToEnd < 0) {
                    yield put(logout());
                    isLicenseExpired = true;
                }

                yield put(licenseCheck(isLicenseExpired));
            }
        }),
        takeEvery(LOCATION_CHANGE, checkNeedUpdatePassword),
        takeEvery(toSuccess(CHANGE_USER_PASSWORD), function* () {
            const user = yield select(getUser.selectData);

            if (prop('needUpdatePassword', user)) {
                yield put(getUser());
                yield history.push(main.path);
            }
        })
    ]);

    const action = yield take(LOCATION_CHANGE);
    yield take(toSuccess(GET_USER));
    yield checkNeedUpdatePassword(action);
}
